import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { PageProps} from "@/craftable-pro/Types/page";

export function useSettings() {
    const settings = computed(() => (usePage().props as PageProps)?.settings);
    const isProduction = computed(() => (usePage().props as PageProps)?.is_production);

    return {
        settings: settings,
        isProduction: isProduction,
    };
}
